import { useEffect } from "react"
import debounce from "@/utility/debounce"

const DEFAULT_SIZE_NAME = "all"
const DEFAULT_DEBOUNCE_TIME = 100 // In Milliseconds

const mediaScreen = [
    ['2xl', '1536px'],
    ['xl', '1280px'],
    ['lg', '1024px'],
    ['md', '768px'],
    ['sm', '640px'],
    ['xs', '380px'],
]

export const useResponsiveScreen = (callback,screenBreakpoints=mediaScreen)=>{

    screenBreakpoints = new Map(screenBreakpoints)
    screenBreakpoints.set(DEFAULT_SIZE_NAME, '0px')

    const screenSizeList = Array.from(screenBreakpoints.keys())

    screenSizeList.forEach(screenSize => {
        screenBreakpoints.set(screenSize,window.matchMedia(`(min-width: ${screenBreakpoints.get(screenSize)})`))
    })

    const getCurrentDeviceSize = ()=>screenSizeList.find(screenSize => screenBreakpoints.get(screenSize).matches) || DEFAULT_SIZE_NAME

    const getDeviceSizeMatrix = (size = getCurrentDeviceSize()) => {
        const getScreenIndex = (target) => screenSizeList.findIndex(screen => screen === target)
        const deviceSizeIndex = getScreenIndex(size)
    
        const isScreen = (result,screenSize) => {
            result[screenSize] = screenSize === size
            return result
        }

        const isBelow = (result,screenSize) => {
            result[screenSize] = getScreenIndex(screenSize) <= deviceSizeIndex 
            return result
        }
        
        const isAbove = (result,screenSize) => {
            result[screenSize] = getScreenIndex(screenSize) >= deviceSizeIndex 
            return result
        }

        return {
            size,
            is: screenSizeList.reduce(isScreen,{}),
            below: screenSizeList.reduce(isBelow,{}),
            above: screenSizeList.reduce(isAbove,{}),
        }
    }

    callback(getDeviceSizeMatrix())
    useEffect(()=>{        
        const wrappedCallback = debounce(() => {
            callback(getDeviceSizeMatrix())
        },DEFAULT_DEBOUNCE_TIME);
    
        window.addEventListener("resize",wrappedCallback)
    
        return ()=>window.removeEventListener("resize",wrappedCallback)
    },[])
}